<template>
  <div class="animated fadeIn">
    <Forms ref="frmAssunto"
      :title="'CADASTRO DE MESA'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      v-on:Clear="onClear"
      v-on:Back="onBack"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-12">
          <label><small v-if="form.nome.required" class="text-danger">*</small> Mesa:</label>
          <div class="input-group">
            <b-form-input
              type="text"
              :placeholder="'Digite o Nome da Mesa'"
              v-model="form.nome.value"
              :maxlength="form.nome.maxlength"
              :required="form.nome.required"
              :state="form.nome.state"
            ></b-form-input>
          </div>
        </div>
      </div>
      <NxSelectPA
        :multiple="false"
        v-model="form.paId.value"
        @update:value="handleSelectUpdate('paId', $event)"
      />
      <NxSelectNxSenhasCategoria
        :multiple="false"
        v-model="form.categorias.value"
        @update:value="handleSelectUpdate('categorias', $event)"
      />
      <NxSelectFuncionario
        :multiple="false"
        :variable="{ idType: 'usuarioId', text: 'Atendente Principal' }"
        v-model="form.atendentePrincipal.value"
        @update:value="handleSelectUpdate('atendentePrincipal', $event)"
      />
      <NxSelectFuncionario
        :multiple="false"
        :variable="{ idType: 'usuarioId', text: 'Atendente Substituto' }"
        v-model="form.atendenteSubstituto.value"
        @update:value="handleSelectUpdate('atendenteSubstituto', $event)"
      />
      <div class="form-group row">
        <div class="col-md-12">
          <b-form-checkbox
            v-model="form.preferencial.value"
            :state="form.preferencial.state"
          >
            Preferencial
          </b-form-checkbox>
        </div>
      </div>
    </Forms>
  </div>
</template>

<script>
import 'vue-select/dist/vue-select.css'
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'
import MesaModel from '@/shared/models/configurations/mesamodel.js'
import { NxSelectPA, NxSelectNxSenhasCategoria, NxSelectFuncionario } from '@/components/nexum/components/custom-selects/index.js'
import MesaForms from './mesa-form.js'
import MesaRepository from '@/shared/http/repositories/nxSenhas/mesa.js'

export default {
  name: 'MesaAdd',
  mixins: [ActionsForm],
  data () {
    return {
      data: MesaModel,
      form: JSON.parse(JSON.stringify(MesaForms)),
      editingId: null
    }
  },
  components: {
    NxSelectPA,
    NxSelectNxSenhasCategoria,
    NxSelectFuncionario
  },
  methods: {
    onBack () {
      this.$emit('Back')
    },
    onEdit (obj) {
      loading.push()
      try {
        this.editingId = obj.id || null

        Tools.SetValueInForm(this.form, this.data, obj)

        this.form.paId.value = obj.pa
          ? { id: obj.pa.id, text: obj.pa.descricao }
          : null

        this.form.categorias.value =
          obj.categorias && obj.categorias.length > 0
            ? { id: obj.categorias[0].id, text: obj.categorias[0].nome }
            : null

        this.form.atendentePrincipal.value = obj.atendentePrincipal
          ? { id: obj.atendentePrincipal.id, text: obj.atendentePrincipal.nome }
          : null

        this.form.atendenteSubstituto.value = obj.atendenteSubstituto
          ? { id: obj.atendenteSubstituto.id, text: obj.atendenteSubstituto.nome }
          : null

        this.form.preferencial.value = obj.preferencial !== undefined ? obj.preferencial : false
      } catch (error) {
        console.error('Erro ao preencher os campos no método onEdit:', error)
        toast.error('Erro ao carregar os dados para edição.')
      } finally {
        loading.pop()
      }
    },
    onUpdate () {
      this.onCreate()
    },
    onCreate () {
      loading.push()

      const payload = {
        id: this.editingId,
        nome: this.form.nome.value,
        paId: this.form.paId.value
          ? (typeof this.form.paId.value === 'object' ? this.form.paId.value.id : this.form.paId.value)
          : null,
        inactive: false,
        categorias: this.form.categorias.value
          ? [{id: this.form.categorias.value.id || this.form.categorias.value.value,
            nome: this.form.categorias.value.text || this.form.categorias.value.nome || ''
          }]
          : [],
        atendentePrincipal: this.form.atendentePrincipal.value
          ? { id: this.form.atendentePrincipal.value }
          : null,
        atendenteSubstituto: this.form.atendenteSubstituto.value
          ? { id: this.form.atendenteSubstituto.value }
          : null,
        preferencial: this.form.preferencial.value
      }

      const request = this.editingId
        ? MesaRepository.Update(payload, this.editingId)
        : MesaRepository.Create(payload)

      request
        .then(() => {
          loading.pop()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch((err) => {
          loading.pop()
          console.error('Erro completo:', err)

          if (err.response && err.response.data && err.response.data.errors) {
            const erros = err.response.data.errors
            erros.forEach(e => {
              if (typeof e === 'string') {
                toast.error(e)
              } else if (e.message) {
                toast.error(e.message)
              } else if (e.defaultMessage) {
                toast.error(e.defaultMessage)
              } else {
                toast.error(JSON.stringify(e))
              }
            })
          } else {
            toast.error('Erro ao salvar a mesa.')
          }
        })
    },
    handleSelectUpdate (fieldName, selectedValue) {
      if (!selectedValue) {
        this.data[fieldName] = null
        this.form[fieldName].value = null
        return
      }

      if (fieldName === 'categorias') {
        if (!Array.isArray(selectedValue)) {
          this.data[fieldName] = [{ id: selectedValue.id || selectedValue.value }]
          this.form[fieldName].value = selectedValue
        } else {
          this.data[fieldName] = selectedValue.map(cat => ({ id: cat.id || cat.value }))
          this.form[fieldName].value = selectedValue
        }
      } else if (['atendentePrincipal', 'atendenteSubstituto'].includes(fieldName)) {
        const id = selectedValue.id || selectedValue.value || selectedValue
        this.data[fieldName] = { id }
        this.form[fieldName].value = id
      } else if (fieldName === 'paId') {
        this.data[fieldName] = selectedValue
        this.form[fieldName].value = selectedValue
      } else {
        const id = selectedValue.id || selectedValue.value || selectedValue
        this.data[fieldName] = id
        this.form[fieldName].value = id
      }
    },
    onClear () {
      this.form = JSON.parse(JSON.stringify(MesaForms))
      this.editingId = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/nxSenhas/mesa/components/add/mesaadd.vue